import React from 'react';
import HopliteProjectPage from './HopliteProjectPage';
import SpeedsilverProjectPage from './SpeedsilverProjectPage';
import CustomBedwarsProjectPage from './CustomBedwarsProjectPage';
import MylesEventProjectPage from './MylesEventProjectPage';
import PluginCommissionProjectPage from './PluginCommissionProjectPage';

const ProjectPageRouter = ({ projectId, project, showTrivia }) => {
  // Route to the appropriate project page based on the project ID
  switch (projectId) {
    case "hoplite":
      return <HopliteProjectPage project={project} showTrivia={showTrivia} />;
    case "speedsilver":
      return <SpeedsilverProjectPage project={project} showTrivia={showTrivia} />;
    case "customBedwars":
      return <CustomBedwarsProjectPage />;
    case "mylesEvent":
      return <MylesEventProjectPage />;
    case "pluginCommission":
      return <PluginCommissionProjectPage />;
    default:
      // Fallback to a simple message if the project type is unknown
      return (
        <div className="max-w-5xl mx-auto p-8">
          <h2 className="text-2xl font-bold mb-4">Unknown Project Type</h2>
          <p>No specific page layout found for project ID: {projectId}</p>
          {project && <p>Project title: {project.title}</p>}
        </div>
      );
  }
};

export default ProjectPageRouter; 